export default __webpack_public_path__ + "static/welcome-woman-l3-1afed0f5ba317527daa5932a6f4f40d2.png";